import store from "../../store";
import api from "../request";
import qs from "qs";
import { Promise } from "q";

function getCountryList(reqData) {
    return api.post("util/get-countries", { reqData }).then(({ data }) => {
        return data;
    });
}
function getInstituteDataTypes(reqData) {
    return api.get("data-tree/get-institute-tree", {}).then(({ data }) => {
        return data;
    });
}
function getClasseses() {
    return api.get("ref/getClasses").then(({ data }) => {
        return data;
    });
}
function getDataTreeWithLevel(reqData) {
    return api
        .post("data-tree/external/get-level", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function getDataTreeWithLevelPublic(reqData) {
    return api
        .post("data-tree/external/get-level-public", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function getTestTarget(reqData) {
    return api.post("ref/get-test-targets", {reqData}).then(({ data }) => {
        return data;
    });
}
function getRefData(reqData) {
    return api.post("ref/get", { reqData }).then(({ data }) => {
        return data;
    });
}
function getSubTypeList(reqData) {
    return api
        .post("ref/get-question-subtypes", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function getComprehensionSubtypes(reqData) {
    return api
        .post("ref/get-comprehension-subtypes", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function getTestSubTypes(reqData) {
    return api.post("ref/get-test-subtypes", { reqData }).then(({ data }) => {
        return data;
    });
}
function getAllModules(reqData) {
    return api.post("module/get-all-modules", { reqData }).then(({ data }) => {
        return data;
    });
}
function getDataTree(reqData) {
    return api.get(`data-tree/get?is_sort=true&with_count=true&parent_id=${reqData.parentIds}&question_type=${reqData.question_type}&sub_subject=${reqData.sub_subject}&target_exam=${reqData.target_exam}`).then(({ data }) => {
        return data;
    });
}
function getTestPatterns(reqData) {
    return api.post("ref/get-test-patterns", {reqData}).then(({ data }) => {
        return data;
    });
}
function getTestTypes(reqData) {
    return api
    .get("ref/get-test-types")
    .then(({ data }) => {
        return data;
    });
}
function getCenters(reqData) {
    console.log();
    return api
    .get(`/center/get-by-institute-id/${reqData.instituteId}`)
    .then(({data}) => {
        return data
    })
}
function getBatchesByCenters(reqData) {
    return api
    .post('/batch/get/',{reqData})
    .then(({data}) => {
        return data
    })
}
function getSubscriptionImpact(reqData) {
    return api
    .post('/product/get-subscription-impact/',{reqData})
    .then(({data}) => {
        return data
    })
}
function answerFeedback(reqData) {
    return api
    .post('/users/answer-feedback',{reqData})
    .then(({data}) => {
        return data
    })
}
function getUserFeedbackQuestion(reqData) {
    return api
    .post('/users/get-feedback-questions',{reqData})
    .then(({data}) => {
        return data
    })
}
function getMYTDataTree(reqData) {
    return api.get(`data-tree/myt-get?is_sort=true&with_count=true&parent_id=${reqData.parentIds}&question_type=${reqData.question_type}&sub_subject=${reqData.sub_subject}&creator_id=${reqData.creator_id}&myt=true&target_exam=${reqData.target_exam}`).then(({ data }) => {
        return data;
    });
}
function getMYTRefData(reqData) {
    return api.post("ref/get-public", { reqData }).then(({ data }) => {
        return data;
    });
}
function getMYTTestPatterns(reqData) {
    return api.post("ref/get-test-patterns-public", {reqData}).then(({ data }) => {
        return data;
    });
}
function getMYTSubTypeList(reqData) {
    return api
        .post("ref/get-question-subtypes-public", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function getPriceDetailsMyt(reqData) {
    return api
        .post("product/get-price-details", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function getBillingDetailsMYT(reqData) {
    return api
        .post("myt/get-billing-details", { reqData })
        .then(({ data }) => {

            return data;
        });
}
function getAllQuestionsCount(reqData){
    return api
        .get(`questions/question-count${reqData.mytUser ? '?myt_user=true' : ''}`)
        .then(({ data }) => {
            return data;
        })
}
function getOMRPattern(reqData) {
    return api.post("ref/omr-pattern", {reqData}).then(({ data }) => {
        return data;
    });
}
function getPyqAndModuleTags() {
    return api.get("ref/pyq-module-tags").then(({ data }) => {
        return data;
    });
}
export default {
    getCountryList,
    getInstituteDataTypes,
    getDataTreeWithLevel,
    getDataTreeWithLevelPublic,
    getTestTarget,
    getClasseses,
    getRefData,
    getComprehensionSubtypes,
    getSubTypeList,
    getTestSubTypes,
	getAllModules,
	getDataTree,
	getTestPatterns,
    getTestTypes,
    getCenters,
    getBatchesByCenters,
    getSubscriptionImpact,
    answerFeedback,
    getUserFeedbackQuestion,
    getMYTDataTree,
    getMYTRefData,
    getMYTTestPatterns,
    getMYTSubTypeList,
    getPriceDetailsMyt,
    getBillingDetailsMYT,
    getAllQuestionsCount,
    getOMRPattern,
    getPyqAndModuleTags
};
